import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'

import persist from './persist'
import session from './session'

Vue.use(Vuex)

/**
 *
 */
export default function (/* { ssrContext } */) {
  const vuexLocal = new VuexPersistence({
    modules: ['persist'],
    storage: window.localStorage
  })

  const Store = new Vuex.Store({
    modules: {
      // then we reference it
      persist,
      session
    },

    plugins: [vuexLocal.plugin],
    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  })

  /*
    if we want some HMR magic for it, we handle
    the hot update like below. Notice we guard this
    code with "process.env.DEV" -- so this doesn't
    get into our production build (and it shouldn't).
  */

  if (process.env.DEV && module.hot) {
    module.hot.accept(['./persist', './session'], () => {
      const newPersist = require('./persist').default
      const newSession = require('./session').default
      Store.hotUpdate({ modules: { persist: newPersist, session: newSession } })
    })
  }

  return Store
}
